'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('shared/styled/components');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {};

exports.default = function (_ref) {
  var style = _ref.style,
      className = _ref.className;
  var customStyles = Object.assign({}, defaultStyles, style);
  return _react2.default.createElement(_components.ThemedSvg, {
    version: '1.1',
    className: className + ' icon',
    id: 'Layer_1',
    xmlns: 'http://www.w3.org/2000/svg',
    x: '0px',
    y: '0px',
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    style: customStyles
  }, _react2.default.createElement('g', {
    id: 'project-list-1200'
  }, _react2.default.createElement('g', {
    id: '_x37_77.1-Dashboard',
    transform: 'translate(-23.000000, -86.000000)'
  }, _react2.default.createElement('g', {
    id: 'side_menu',
    transform: 'translate(-8.000000, -45.000000)'
  }, _react2.default.createElement('g', {
    id: 'Group-4',
    transform: 'translate(8.000000, 108.000000)'
  }, _react2.default.createElement('g', {
    id: 'Group-14',
    transform: 'translate(23.000000, 23.000000)'
  }, _react2.default.createElement('rect', {
    id: 'Rectangle',
    x: '1',
    y: '1',
    className: 'st0',
    width: '6',
    height: '14'
  }), _react2.default.createElement('rect', {
    id: 'Rectangle-Copy',
    x: '8',
    y: '1',
    className: 'st0',
    width: '7',
    height: '5'
  }), _react2.default.createElement('rect', {
    id: 'Rectangle-Copy-2',
    x: '8',
    y: '7',
    className: 'st0',
    width: '7',
    height: '5'
  }), _react2.default.createElement('rect', {
    id: 'Rectangle-Copy-3',
    x: '8',
    y: '13',
    className: 'st0',
    width: '7',
    height: '2'
  })))))));
};